<template>
    <v-calendar ref="calendar" v-model="value" color="primary" :value="value" :type="typeView" :mode="mode"
        :weekdays="weekdays" :locale="localeLang" :eventMoreText="eventMoreText" :events="events"
        :interval-minutes="intervalMinutes" :interval-count="intervalCount" :interval-format="intervalFormat" category-show-all :categories="categories"
        :short-intervals="false" :short-weekdays="false" :event-color="getEventColor" @click:event="showEvent"
        @mousedown:event="startDrag" @mousedown:time="startTime" @mousemove:time="mouseMove" @mouseup:time="endDrag"
        @mouseleave.native="cancelDrag" @click:more="viewDay" @click:date="viewDay" @mousedown:time-category="dayCategory">
        <template v-slot:day-label-header="day">
            <v-btn depressed text fab @click="viewDay(day)">{{ day.day }}</v-btn>
            <div class="v-calendar-daily_head-weekday primary--text custom">{{ getDayName(day.weekday) }}</div>
        </template>
        <template v-slot:event="{ event, timed}">
            <div class="v-event-draggable" :style="getEventStyle(event)" 
                :class="{ 'event-cancelled': event.IsEventCancelled, 'event-confidential': event.IsConfidential, 'event-owner': event.IsOwner }"
                @dblclick="openEventDoubleClick"
            >
                    <strong>{{ event.name }}</strong> 
                    <span>{{ delimiterContent(event.start, event.end).delimiter }}</span>
                    <span :class="{'eventTime': delimiterContent(event.start, event.end).useStyle}">{{ formatTime(event.start) }} - {{ formatTime(event.end) }}</span>
            </div>
            <div v-if="timed && (!event.IsConfidential || event.IsOwner)" class="v-event-drag-bottom" @mousedown.stop="extendBottom(event)" @mouseup.stop="endDrag"
                @click.stop>
            </div>
        </template>
    </v-calendar>
</template>

<script>
export default {
    inheritAttrs: false,
    data() {
        return {
            value: '',
            dragEvent: null,
            dragStart: null,
            createEvent: null,
            createStart: null,
            extendOriginal: null,
            originalEvent: null,
            isDragging: false,
            currentCategory: '',
            percentLightness: 0.87,
            doubleClickEmited: false,
            endDragEvent:false
        }
    },
    props: {
        typeView: {
            type: String,
            default: () => 'week'
        },
        mode: {
            type: String,
            default: () => 'stack'
        },
        weekdays: {
            type: [Array, Object],
            default: () => [0, 1, 2, 3, 4, 5, 6]
        },
        events: {
            type: [Array, Object],
            default: () => []
        },
        localeLang: {
            type: String,
            default: ''
        },
        intervalMinutes: {
            type: String,
            default: () => '30'
        },
        intervalCount: {
            type: String,
            default: () => '48'
        },
        eventMoreText: {
            type: String,
            default: ''
        },
        eventName: {
            type: String,
            default: ''
        },
        categories: {
            type: [Array, Object],
            default: () => []
        },
        dayResources: {
            type: Array,
            required: true,
            default: () => []
        },
        stickyHeader:{
            type:Boolean,
            default:false
        }
    },
    mounted() {
        this.$refs.calendar.checkChange();

        /* if the stickyHeader prop is active then we launch the method to block the header when scrolling */
        if(this.stickyHeader){
            this.setStickyHeader();
        }

    },
    computed: {
        mainColor() {
            // get css variable --main-color
            var r = document.querySelector(':root');
            var rs = getComputedStyle(r);
            return rs.getPropertyValue('--main-color');
        },
        /**
         * events linked the drag action
         */
        getDragEvents(){
            return {
                'dragTime': this.dragTime,
                'dragEvent': this.dragEvent,
                'createEvent': this.createEvent,
                'createStart': this.createStart,
                'extendOriginal': this.extendOriginal,
                'originalEvent': this.originalEvent
            }
        }
    },
    methods: {
        delimiterContent(start, end) {
            const dateStart = new Date(start);
            const dateEnd = new Date(end);
            const hours = dateEnd.getHours() - dateStart.getHours();
            const minutes = dateEnd.getMinutes() - dateStart.getMinutes();

            if(hours == 0 && (minutes <= 30 && minutes > 0)) {
                return {useStyle: false, delimiter: ', '}
            } 
            else {
                return {useStyle: true, delimiter: ''}
            }
        },
        intervalFormat(interval) {
            return  interval.time;
        },
        formatTime(time) {
            const date = new Date(time);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const formattedHours = hours < 10 ? '0' + hours : hours;
            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
            return formattedHours + ':' + formattedMinutes;
        },
        getEventColor(event) {
            if (event === this.createEvent) {
                if (event.eventColor && event.eventColor != "" ) {
                    if(event.IsDraggable) {
                        return this.shadeStringColor(event.eventColor, this.percentLightness)
                    }
                }
                return this.shadeStringColor(this.mainColor, this.percentLightness)
            } 
            else {
                if (event.eventColor && event.eventColor != "" ) {
                    return this.shadeStringColor(event.eventColor, this.percentLightness)
                } else {
                    return this.shadeStringColor(this.mainColor, this.percentLightness)
                }
            }
        },
        /**
         * Convert any color to rgb color and darken or lighten it
         * @param {string} color color
         * @param {Int} percent between -1 and 1, dark to light
         */
        shadeStringColor(color, percent) {
            let a = document.createElement('div');
            a.style.color = color;
            let colors = window.getComputedStyle(document.body.appendChild(a)).color.match(/\d+/g).map(function (a) { return parseInt(a, 10); });
            document.body.removeChild(a);
            color = `rgb(${colors.join(',')})`;
            let f = color.split(","), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = parseInt(f[0].slice(4)), G = parseInt(f[1]), B = parseInt(f[2]);
            return "rgb(" + (Math.round((t - R) * p) + R) + "," + (Math.round((t - G) * p) + G) + "," + (Math.round((t - B) * p) + B) + ")";
        },
        getEventStyle(event) {
            if (event.eventColor && event.eventColor != "") {
                return "border-left: 5px solid " + event.eventColor;
            }
        },
        dayCategory({ category }) {
            this.currentCategory = category;
        },
        viewDay({ date }) {
            this.$emit('viewDay', { 'date': date });
        },
        showEvent({ nativeEvent, event, day }) {
            this.$emit('showEvent', { 'nativeEvent': nativeEvent, 'event': event,'day': day });
        },
        setValue(value) {
            this.value = value
        },
        startDrag({ event, timed }) {
            if (event && timed) {
                this.originalEvent = { ...event }
                this.dragEvent = event
                this.dragTime = null
                this.extendOriginal = null
            }
            this.isDragging = true
        },
        startTime(tms) {
            const mouse = this.toTime(tms)
            this.isDragging = true
            if (this.dragEvent && this.dragTime === null) {
                if (!this.dragEvent.IsUpdatable || !this.dragEvent.IsDraggable) {
                    this.isDragging = false
                    return
                }
                else {
                    const start = this.dragEvent.start
                    this.dragTime = mouse - start
                }

            } else {
                this.createStart = this.roundTime(mouse)
                // add 15min to createStart timestamp
                this.createEnd = this.createStart + 1800000
                this.createEvent = {
                    name: this.eventName,
                    start: this.createStart,
                    end: this.createEnd,
                    timed: true,
                    IsUpdatable: true,
                    category: this.currentCategory,
                }
                this.events.push(this.createEvent)
                this.dragEvent = this.createEvent
                this.originalEvent = null
            }
        },
        extendBottom(event) {
            if (event.IsDraggable) {
                this.dragEvent = event;
                this.createEvent = event
                this.createStart = event.start
                this.extendOriginal = event.end
                this.originalEvent = { ...event }
            }
            this.isDragging = true
        },
        mouseMove(tms) {
            if (this.isDragging && !this.endDragEvent) {
                const mouse = this.toTime(tms)
                if (this.dragEvent && this.dragTime !== null && this.dragTime != undefined) {
                    if (this.dragEvent.IsUpdatable && this.dragEvent.IsDraggable) {
                        const start = this.dragEvent.start
                        const end = this.dragEvent.end
                        const duration = end - start
                        const newStartTime = mouse - this.dragTime
                        const newStart = this.roundTime(newStartTime)
                        const newEnd = newStart + duration

                        this.dragEvent.start = newStart
                        this.dragEvent.end = newEnd
                    }

                } else if (this.createEvent && this.createStart !== null) {
                    const mouseRounded = this.roundTime(mouse, false)
                    const min = Math.min(mouseRounded, this.createStart)
                    const max = Math.max(mouseRounded, this.createStart)

                    this.createEvent.start = min
                    this.createEvent.end = max
                }
            }
        },
        endDrag() {
            this.endDragEvent = true;
            let oDragEndEvent = this.getDragEvents;            
            
            /*Timeout prevent the double click to be emitted at 
            the same moment as the drag event 
            More detail on the commit */
            setTimeout(()=>{
                if(!this.doubleClickEmited) {
                    this.$emit('endDrag', oDragEndEvent);
                    this.emptyDragEvents();
                    this.extendOriginal = null;
                    this.currentCategory = '';
                }
                this.endDragEvent = false;
            },1000)
        },
        cancelDrag() {
            if (this.createEvent) {
                if (this.extendOriginal) {
                    this.createEvent.end = this.extendOriginal
                } else {
                    const i = this.events.indexOf(this.createEvent)
                    if (i !== -1) {
                        this.events.splice(i, 1)
                    }
                }
            } else if (this.isDragging) {
                this.$emit('reloadDatas');
            }

            this.emptyDragEvents();
            this.isDragging = false
        },
        roundTime(time, down = true) {
            const roundTo = 30 // minutes
            const roundDownTime = roundTo * 60 * 1000

            return down
                ? time - time % roundDownTime
                : time + (roundDownTime - (time % roundDownTime))
        },
        toTime(tms) {
            return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
        },
        openEventDoubleClick() {
            this.doubleClickEmited = true;
            this.$emit('createEdit', { nTab: this.nTab, nFileId: this.nFileId });
        },
        emptyDragEvents(){
            this.createEvent = null;
            this.createStart = null;
            this.dragTime = null;
            this.dragEvent = null;
        },
        /**
         * Method to get the names of the days of the week
         * @param {Int} dayId id of the date
         */
        getDayName(weekday) {
            // Ensure dayResources is defined and is an array
            if (Array.isArray(this.dayResources)) {
                const day = this.dayResources.find(item => item.id === weekday);
                return day ? day.value : ''; // Return the corresponding day name or empty if not found
            }
            return ''; // Fallback if dayResources is not defined correctly
        },
        /** Block the header to the top */
        setStickyHeader(){
            let dayHeader = document.querySelector('.v-calendar-daily__head');

            if(!dayHeader) return false;
            // We remove the old event listener when switching from day mode to week mode
            // and return to the top
            dayHeader.removeEventListener('scroll',this.addStickyClass);
            dayHeader.scrollTo({
                top: 0,
                left: 0
            });
            dayHeader?.addEventListener('scroll',this.addStickyClass);
        },
        /** Add sticky class when scrolling in the header part
         * @param {any} e scroll event
         */
        addStickyClass(e){
            let dayHeaderLabel = [...document.querySelectorAll('.v-calendar-daily_head-day-label')];
            
            if(!dayHeaderLabel) return false;

            let scrollY = e.target.scrollTop;
            dayHeaderLabel.map(label => label.style.top = scrollY + 'px' );
            if(scrollY > 0){
                dayHeaderLabel.map(label => label.classList.add('isSticky'));
            }else{
                dayHeaderLabel.map(label => label.classList.remove('isSticky'));
            }
        }
    },
    watch: {
        value: function () {
            this.$emit('calendarChange', this.value)
        },
        /**
         * When we switch from day to week or the contrary, we need to compute the sticky header again
         */
        typeView: function () {
            if(this.stickyHeader){
                this.setStickyHeader();
            }
        }, 
    }
}
</script>

<style lang="scss">

.event-cancelled strong {
    text-decoration: line-through 2px;
}

.event-confidential:not(.event-owner) {
    background: #bbbbbb !important;
}

.v-event-draggable>span.v-event-summary {
    height: 100%;
}

.v-event-timed {
    user-select: none;
    -webkit-user-select: none;
}

.v-event-drag-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 10px;
    cursor: ns-resize;

    &::after {
        display: none;
        position: absolute;
        left: 50%;
        height: 4px;
        border-top: 1px solid white;
        border-bottom: 1px solid white;
        width: 16px;
        margin-left: -8px;
        opacity: 0.8;
        content: "";
    }

    &:hover::after {
        display: block;
    }
}

.eventTime {
    display: flex;
    white-space: normal;
}

.v-calendar-daily_head-day-label.isSticky {
    position:relative;
    width:100%;
}

</style>